import { Row } from '@folio/stripes/components';
import React, { useMemo } from 'react';
import { useField } from 'react-final-form';
import { DataTokenType } from '../../../types';
import AmountWithDecimalToken from '../Shared/AmountWithDecimalToken';
import ArbitraryTextToken from '../Shared/ArbitraryTextToken';
import CurrentDateToken from '../Shared/CurrentDateToken';
import WhitespaceToken from '../Shared/WhitespaceToken';
import AccountDateToken from './AccountDateToken';
import FeeFineTypeToken from './FeeFineTypeToken';
import ItemInfoToken from './ItemInfoToken';
import UserInfoToken from './UserInfoToken';
import ConstantConditionalToken from './ConstantConditionalToken';
export var EMPTY_BODY_TYPES = [
    DataTokenType.COMMA,
    DataTokenType.NEWLINE,
    DataTokenType.NEWLINE_MICROSOFT,
    DataTokenType.TAB,
    DataTokenType.AGGREGATE_COUNT,
];
export function isDataBodyEmpty(type) {
    return EMPTY_BODY_TYPES.includes(type !== null && type !== void 0 ? type : DataTokenType.NEWLINE);
}
export default function DataTokenCardBody(_a) {
    var name = _a.name;
    var type = useField("".concat(name, ".type"), {
        subscription: { value: true },
        format: function (value) { return value !== null && value !== void 0 ? value : DataTokenType.NEWLINE; },
    }).input.value;
    var cardInterior = useMemo(function () {
        switch (type) {
            case DataTokenType.ARBITRARY_TEXT:
                return (React.createElement(Row, null,
                    React.createElement(ArbitraryTextToken, { prefix: "".concat(name, ".") })));
            case DataTokenType.SPACE:
                return (React.createElement(Row, null,
                    React.createElement(WhitespaceToken, { prefix: "".concat(name, ".") })));
            case DataTokenType.CURRENT_DATE:
                return (React.createElement(Row, null,
                    React.createElement(CurrentDateToken, { prefix: "".concat(name, ".") })));
            case DataTokenType.AGGREGATE_TOTAL:
            case DataTokenType.ACCOUNT_AMOUNT:
                return (React.createElement(Row, null,
                    React.createElement(AmountWithDecimalToken, { prefix: "".concat(name, ".") })));
            case DataTokenType.ACCOUNT_DATE:
                return (React.createElement(Row, null,
                    React.createElement(AccountDateToken, { prefix: "".concat(name, ".") })));
            case DataTokenType.FEE_FINE_TYPE:
                return (React.createElement(Row, null,
                    React.createElement(FeeFineTypeToken, { prefix: "".concat(name, ".") })));
            case DataTokenType.ITEM_INFO:
                return (React.createElement(Row, null,
                    React.createElement(ItemInfoToken, { prefix: "".concat(name, ".") })));
            case DataTokenType.USER_DATA:
                return (React.createElement(Row, null,
                    React.createElement(UserInfoToken, { prefix: "".concat(name, ".") })));
            case DataTokenType.CONSTANT_CONDITIONAL:
                return (React.createElement(Row, null,
                    React.createElement(ConstantConditionalToken, { prefix: "".concat(name, ".") })));
            default:
                return React.createElement("div", null);
        }
    }, [type, name]);
    return React.createElement("div", null, cardInterior);
}
